import ComoExpertsChat from "../Components/ComoAgents/ComoExpertsChat";

const ComoExpertsChatPage = () => {
  return <ComoExpertsChat />;
};

export default ComoExpertsChatPage;
